export const changeQualityReducer = (state = '', action) => {
    switch (action.type) {
      case "CHANGE_QUALITY":
        return action.payload.quality;
      default:
        return state;
    }
  };
  